/**
 * Gemini 3.5 Transcribe — model ids and user-facing copy for the per-app try-it overlay.
 * @see https://ai.google.dev/gemini-api/docs/transcribe
 */

/** Live API streaming speech-to-text. */
export const GEMINI_35_TRANSCRIBE_LIVE_MODEL = 'gemini-3.5-transcribe-live';

/** Interactions API batch / pre-recorded speech-to-text. */
export const GEMINI_35_TRANSCRIBE_BATCH_MODEL = 'gemini-3.5-transcribe';

export const GEMINI35_TRANSCRIBE_SWITCH_LABEL =
  'Try Gemini 3.5 Transcribe (preview)';

export const GEMINI35_TRANSCRIBE_HIPAA_HELPER = 'May not be HIPAA-compliant.';

export const GEMINI35_TRANSCRIBE_HIPAA_HELPER_DETAIL =
  "Preview. Audio is sent to Google's Gemini API.";

export const GEMINI35_TRANSCRIBE_CHIP_LABEL =
  'STT: Gemini 3.5 Transcribe — may not be HIPAA-compliant';

export const GEMINI35_TRANSCRIBE_OVERRIDE_HELPER =
  'Temporarily overrides the STT provider above. Turn off to restore.';

/** @typedef {'smart' | 'verbatim'} Gemini35TranscribeMode */
